import './App.css';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import AppNav from './components/AppNav';
import Arena from './pages/Arena';
import Stats from './pages/Stats';
import Login from './pages/Login';  
import Tests from './pages/Tests';
import ArenaQuestion from './pages/ArenaQuestion';
import Test from './pages/Test';
import Signup from './pages/Signup';
import TestReview from './pages/TestReview';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import logo from './images/logo.png';
import { Analytics } from '@vercel/analytics/react';

const publicPaths = ['/', '/login', '/signup', '/forgot-password', '/reset-password'];

function App() {
  const location = useLocation();

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  
  const loadingComponent = () => {
    return (
      <div className='loading-screen'>
        <img src={logo} alt='πPrep' className='loading-logo' />
        <div className='loading-dots'>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    );
  }

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {fetchProfile(session.access_token);} 
      else {setLoading(false);}
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event) => {
        if (event === 'SIGNED_OUT') {setUser(null);}
      }
    );

    return () => subscription.unsubscribe();
  }, []);

  const fetchProfile = async (token) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE}/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.success) setUser(data.user);
    } 
    catch (err) {
      console.error('Failed to fetch profile:', err);
    } 
    finally {
      setLoading(false);
    }
  };

  if (loading) return loadingComponent();

  const protect = (element) => user ? element : <Navigate to="/login" replace />;

  return (
    <>
      {!publicPaths.includes(location.pathname) && (
        <AppNav user={user} setUser={setUser}/>
      )}
      <Routes>
        <Route path="/" element={<Home user={user} />} />
        <Route path="/login" element={<Login user={user} setUser={setUser}/>} />
        <Route path="/signup" element={<Signup setUser={setUser} />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/arena" element={protect(<Arena user={user}/>)} />
        <Route path="/stats" element={protect(<Stats user={user} />)} />
        <Route path="/tests" element={protect(<Tests user={user} />)} />
        <Route path="/arena/algebra" element={protect(<ArenaQuestion user={user} topic="Algebra" sql="algebra"/>)} />
        <Route path="/arena/advanced-math" element={protect(<ArenaQuestion user={user} topic="Advanced Math" sql="advanced_math" />)} />
        <Route path="/arena/problem-solving-and-data-analysis" element={protect(<ArenaQuestion user={user} topic="Problem Solving & Data Analysis" sql="problem_solving_and_data_analysis" />)} />
        <Route path="/arena/geometry-and-trigonometry" element={protect(<ArenaQuestion user={user} topic="Geometry & Trigonometry" sql="geometry_and_trigonometry" />)} />
        <Route path="/tests/:testId" element={protect(<Test user={user} />)} />
        <Route path="/tests/:testId/review" element={protect(<TestReview user={user} />)} />
      </Routes>
      <Analytics />
    </>
  );
}

export default App;
